export var DimeState = {
    dime: undefined,
    dimeDisabled: false,
    dimeLoadPromise: undefined,
};
//# sourceMappingURL=dimeState.js.map